import { useEffect, useState } from "react";
import { fetchDisbursements } from "../Api/ViewDisbursement";
import { Container, Table } from "react-bootstrap";
//import "../Styling/ViewDisbursement.css";
import { toast } from "react-toastify";
import moment from "moment";

const ViewDisbursement = () => {
  const [disbursements, setDisbursements] = useState([]);

  useEffect(() => {
    const loadDisbursements = async () => {
      try {
        const data = await fetchDisbursements();
        setDisbursements(data || []);
      } catch (error) {
        toast.error(`🦄 Error Fetching Disbursements`);
      }
    };

    loadDisbursements();
  }, []);

  return (
    <>
        <div className="main-content expand">
          <Container fluid className="list-container">
            <span className="list-title">View Disbursements</span>

            {disbursements.length > 0 ? (
              <div className="table-wrapper">
                <div className="table-scroll-container">
                  <Table bordered hover className="data-table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Transaction ID</th>
                        <th>Beneficiary Name</th>
                        <th>Beneficiary Bank Details</th>
                        <th>Amount to be Disbursed</th>
                        <th>Mode of Payment</th>
                        <th>Date of Disbursement</th>
                        <th>Disbursed By</th>
                        <th>Remarks</th>
                        <th>Created At</th>
                        <th>Created By</th>
                        <th>Advance Request ID</th>
                      </tr>
                    </thead>
                    <tbody>
                      {disbursements.map((disbursement, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{disbursement.transactionid}</td>
                          <td>{disbursement.beneficiaryName}</td>
                          <td>{disbursement.beneficiaryBankDetails}</td>
                          <td>{disbursement.amountToBeDisbursed}</td>
                          <td>{disbursement.modeOfPayment}</td>
                          <td>{new Date(disbursement.dateOfDisbursement).toLocaleDateString()}</td>
                          <td>{disbursement.disbursedBy}</td>
                          <td>{disbursement.remarks}</td>
                          <td>{moment(disbursement.createdAt).format('L')}</td>
                          <td>{disbursement.createdBy}</td>
                          <td>{disbursement.advanceReqId}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </div>
            ) : (
              <p className="no-data">No disbursements found.</p>
            )}
          </Container>
        </div>
    </>
  );
};

export default ViewDisbursement;